import { Button, Empty, Space } from "antd";
import { Trans, useTranslation } from "react-i18next";

interface EasEmptyProps {
  onClear: () => void;
}

export default function EASSearchEmpty({ onClear }: EasEmptyProps) {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column"
      }}
    >
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <div>
            <Trans>
              <div style={{ color: "#6D7175" }}>{t("easApplications.empty")}</div>
            </Trans>
            <br />
            <Space direction="vertical" align="center" style={{ width: "100%" }}>
              <Button type="link" className="center-content" onClick={onClear}>
                {t("easApplications.search.clear")}
              </Button>
            </Space>
          </div>
        }
      />
    </div>
  );
}
